import script from "./InfoItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoItem.vue?vue&type=script&setup=true&lang=js"

import "./InfoItem.vue?vue&type=style&index=0&id=af03a06e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af03a06e"]])

export default __exports__